/**
 * Générateur pseudo-aléatoire déterministe (mulberry32), seedé par l'appelant.
 * C'est la SEULE source d'aléa autorisée dans le moteur (CLAUDE.md règle 3).
 * Les constantes ci-dessous sont celles de l'algorithme, pas des chiffres économiques.
 */
export interface Rng {
  /** Flottant dans [0, 1). */
  next(): number;
}

export function createRng(seed: number): Rng {
  let a = seed >>> 0;
  return {
    next() {
      a = (a + 0x6d2b79f5) >>> 0;
      let t = a;
      t = Math.imul(t ^ (t >>> 15), t | 1);
      t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    },
  };
}

/**
 * Graine d'un flux d'aléa secondaire (ex. votes du budget) dérivée de la graine de la partie : flux indépendants, pour que la
 * consommation de l'un (événements) ne décale pas l'autre (votes) — l'attribution rejoue ainsi les mêmes tirages (ADR 0009 §4).
 * Constante = multiplicateur de Knuth (algorithme), pas un chiffre économique.
 */
export function deriveSeed(seed: number, stream: number): number {
  return (Math.imul((seed >>> 0) ^ Math.imul(stream, 0x9e3779b1), 0x85ebca6b) ^ stream) >>> 0;
}

/**
 * Graine du jour (défi quotidien) : hachage déterministe (FNV-1a 32 bits) de la date ISO `AAAA-MM-JJ` fournie par l'appelant.
 * Le moteur ne lit jamais l'horloge : l'UI passe la date. Constantes = celles de FNV-1a (algorithme), pas des chiffres économiques.
 */
export function dailySeed(dateISO: string): number {
  const d = dateISO.trim().slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(d)) throw new Error(`dailySeed : date ISO attendue (AAAA-MM-JJ), reçu « ${dateISO} »`);
  let h = 0x811c9dc5;
  for (let i = 0; i < d.length; i++) {
    h ^= d.charCodeAt(i);
    h = Math.imul(h, 0x01000193) >>> 0;
  }
  return h >>> 0;
}
